import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { QueryResponse } from '../../core/services/QueryResponse';
import { ModelResponse } from '../../core/services/ModelResponse';
import { ExtractMetadataModel } from '../models/ExtractMetadataModel';
import { DownloadFileService } from '../../common/utilities/DownloadFileService';

@Injectable()
export class ExtractReportServiceFactory {
  constructor(private httpClient: HttpClient, private downloadFileService: DownloadFileService) {}

  getService(baseUrl: string): ExtractReportService {
    return new ExtractReportService(this.httpClient, this.downloadFileService, baseUrl);
  }
}

export class ExtractReportService {
  constructor(private httpClient: HttpClient, private downloadFileService: DownloadFileService, private baseUrl: string) {}

  listQuery(parameters: any, page: number, pageSize: number, sort: string, sortDirection: string): Observable<QueryResponse<any>> {
    var params = new HttpParams().set('skip', (page * pageSize).toString()).set('take', pageSize.toString());
    if (sort) {
      params = params.set('sort', sort).set('sortDirection', sortDirection);
    }
    return this.httpClient.post<QueryResponse<any>>(`${this.baseUrl}/ListQuery`, parameters, { params: params });
  }

  totalCount(parameters: any): Observable<ModelResponse<number>> {
    return this.httpClient.post<ModelResponse<number>>(`${this.baseUrl}/TotalCount`, parameters);
  }

  getExportUrl(parameters: any, page: number, pageSize: number, sort: string, sortDirection: string): Observable<ModelResponse<string>> {
    parameters['skip'] = page * pageSize;
    parameters['take'] = pageSize;
    if (sort) {
      parameters['sort'] = sort;
      parameters['sortDirection'] = sortDirection;
    }
    return this.httpClient.post<Blob>(`${this.baseUrl}/Export`, parameters, { responseType: 'blob' as 'json', observe: 'response' }).map((r) => {
      this.downloadFileService.export(r, parameters);
      var response = new ModelResponse<string>();
      response.model = parameters.url;
      return response;
    });
  }

  openExtract(url: string, parameters: any): void {
    this.downloadFileService.openExtract(url, parameters);
  }

  getExtractMetadata(): Observable<ModelResponse<ExtractMetadataModel>> {
    return this.httpClient.get<ModelResponse<ExtractMetadataModel>>(`${this.baseUrl}/ExtractMetadata`);
  }
}



// WEBPACK FOOTER //
// ./src/app/report/services/ExtractReportService.ts